import { useCallback, useState } from 'react';

import { useRestrictionLiftedObserver } from './useRestrictionLiftedObserver';

export const useAutoProgress = ({ autoProgress, onProgress }: { autoProgress?: boolean; onProgress: () => void }) => {
  const [autoProgressStarted, setAutoProgressStarted] = useState(false);
  // eslint-disable-next-line no-undef
  const [currentAutoProgressTimeout, setCurrentAutoProgressTimeout] = useState<NodeJS.Timeout | null>(null);
  const progress = () => {
    if (!autoProgress) {
      return;
    }
    setAutoProgressStarted(true);
    setCurrentAutoProgressTimeout(
      setTimeout(() => {
        onProgress();
        setAutoProgressStarted(false);
      }, 1.5 * 1000)
    );
  };

  const cancelAutoProgress = useCallback(() => {
    if (currentAutoProgressTimeout) {
      clearTimeout(currentAutoProgressTimeout);
    }
    setAutoProgressStarted(false);
    setCurrentAutoProgressTimeout(null);
  }, [currentAutoProgressTimeout]);

  useRestrictionLiftedObserver(progress, cancelAutoProgress);
  return { autoProgressStarted };
};
